import React from 'react';
import { Box, Grid, Typography, CircularProgress, Paper } from '@mui/material';
import SupportIssueCard from './SupportIssueCard';

const PRIMARY = '#f25d27';

/**
 * @param {{
 *   issues: import('../../types/support').SupportIssueViewModel[];
 *   isLoading: boolean;
 *   error: string | null;
 *   onSelectIssue: (issue: import('../../types/support').SupportIssueViewModel) => void;
 * }} props
 */
export default function SupportIssueGrid({
  issues,
  isLoading,
  error,
  onSelectIssue,
}) {
  if (isLoading) {
    return (
      <Paper
        elevation={0}
        sx={{
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <CircularProgress sx={{ color: PRIMARY }} />
        </Box>
      </Paper>
    );
  }

  if (error) {
    return (
      <Paper
        elevation={0}
        sx={{
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <Typography sx={{ color: '#d32f2f', fontSize: '0.9rem' }}>{error}</Typography>
        </Box>
      </Paper>
    );
  }

  if (!issues.length) {
    return (
      <Paper
        elevation={0}
        sx={{
          borderRadius: '8px',
          border: '1px solid #e0e0e0',
          boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
          <Typography sx={{ color: '#aaa', fontSize: '0.9rem' }}>
            Nenhum chamado encontrado.
          </Typography>
        </Box>
      </Paper>
    );
  }

  return (
    <Grid container spacing={2}>
      {issues.map((issue) => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={issue.id}>
          <SupportIssueCard
            issue={issue}
            onClick={() => onSelectIssue(issue)}
          />
        </Grid>
      ))}
    </Grid>
  );
}
